namespace Solovis.Portal.TxServices {

    export interface TxInvestmentCachedMarketValueData {
        marketValue?: number | null;
        marketValueDayId?: number | null;
        marketValueStr?: string | null;
    }

    /**
     * TxCachedMarketValueManager manages the set of pre-trade market values retrieved from the server.
     * For a given (investmentId, dayId) it returns the most recent available total market value for the
     * position on or before that day, used by the pro forma transaction editor summary table.
     */
    export class TxCachedMarketValueManager {

        private _portalServices: Solovis.Portal.IPortalServices;

        public _keyToHolderMap;

        constructor(options?: {
            portalServices?: Solovis.Portal.IPortalServices;
        }) {

            if (options && options.portalServices) {
                this._portalServices = options.portalServices;
            }
            else {
                this._portalServices = new Solovis.Portal.SitePortalServices();
            }

            this._keyToHolderMap = {};
        }

        public _getScalarKey(investmentId, dayId) {
            return "" + dayId + "-" + investmentId;
        };

        public registerMarketValueData(investmentId, dayId, marketValueData: TxInvestmentCachedMarketValueData) {
            var key = this._getScalarKey(investmentId, dayId);

            var holder = this._keyToHolderMap[key];
            if (!holder) {
                holder = {};
                this._keyToHolderMap[key] = holder;
            }

            holder.marketValueData = marketValueData;

            if (holder.callbacks) {
                $(holder.callbacks).each(function (i, callback: any) {
                    try {
                        callback(holder.marketValueData);
                    }
                    catch (ex) {
                        console.log("TxCachedMarketValueManager callback error");
                        console.log(ex);
                    }
                });
            }
        }


        /*
         * getMarketValueDataAsync will request the marketValueData and callback(marketValueData) will be called with the result.
         */
        public async getMarketValueDataAsync(
            investmentId,
            dayId,
            callback: (data: TxInvestmentCachedMarketValueData) => void = null): Promise<TxInvestmentCachedMarketValueData> {

            var self = this;

            var key = this._getScalarKey(investmentId, dayId);

            var holder = this._keyToHolderMap[key];
            if (!holder) {
                holder = {
                    dayId: dayId,
                    investmentId: investmentId
                };
                this._keyToHolderMap[key] = holder;
            }

            if (holder.marketValueData) {
                if (callback) {
                    callback(holder.marketValueData);
                }

                return holder.marketValueData;
            }
            else {
                if (!holder.callbacks) {
                    holder.callbacks = [];
                }

                if (callback) {
                    holder.callbacks.push(callback);
                }

                if (!holder.loadPending) {
                    holder.loadPending = true;

                    let marketValueResponse = await this._portalServices.rpc().invoke(
                        "~/DataManagement/TransactionEditor/GetMarketValueData",
                        { investmentId: investmentId, dayId: dayId });

                    let marketValueData: TxInvestmentCachedMarketValueData = marketValueResponse.result;

                    this.registerMarketValueData(investmentId, dayId, marketValueData);

                    holder.loadPending = false;

                    return marketValueData;
                }
                else if (!callback) {
                    // We called using async/await style and need to register callback to make sure we get called when prior load completes.
                    return new Promise<TxInvestmentCachedMarketValueData>(function (resolve, reject) {
                        holder.callbacks.push((marketValueData) => {
                            resolve(marketValueData);
                        });
                    });
                }
            }
        };

    }

}
